import { normalizeLocale, resources } from '@runnerboy/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const saved = (() => {
  try {
    return localStorage.getItem('rb.locale');
  } catch {
    return null;
  }
})();

void i18n.use(initReactI18next).init({
  resources,
  lng: normalizeLocale(saved ?? navigator.language),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(code: string) {
  const l = normalizeLocale(code);
  void i18n.changeLanguage(l);
  document.documentElement.lang = l;
  try {
    localStorage.setItem('rb.locale', l);
  } catch {
    /* ignore */
  }
}

export default i18n;
